import { render, staticRenderFns } from "./_settings.vue?vue&type=template&id=4f023f30&scoped=true&"
import script from "./_settings.vue?vue&type=script&lang=js&"
export * from "./_settings.vue?vue&type=script&lang=js&"
import style0 from "./_settings.vue?vue&type=style&index=0&id=4f023f30&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f023f30",
  null
  
)

export default component.exports